import { render, staticRenderFns } from "./SparepartIndex.vue?vue&type=template&id=b0dcb0c8&scoped=true&"
import script from "./SparepartIndex.vue?vue&type=script&lang=js&"
export * from "./SparepartIndex.vue?vue&type=script&lang=js&"
import style0 from "./SparepartIndex.vue?vue&type=style&index=0&id=b0dcb0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dcb0c8",
  null
  
)

export default component.exports